import { message, Select } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  ButtonItem,
  InputItem,
  InputNumberItem,
  ErrorItem,
  DatePickerItem,
  SelectItem
} from "../../../../Components/Items";
import moment from "moment";



const { Option } = Select;

class EditarPaciente extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible) {
      this.consultarTodo();
    }
  }

  onFinishFailed(e) {
    ErrorItem(e);
  };

  consultarTodo() {
    this.setState({ loading: true });
    axios
      .post(
        "pacientes/datosPaciente",
        { empresaId: this.props.empresaId, pacienteId: this.props.pacienteId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          const paciente = res.data.paciente;

          //Convertir fecha para que sea compatible con el DatePicker 
          if (paciente.fechaNacimiento && moment(paciente.fechaNacimiento).isValid()) {
            paciente.fechaNacimiento = moment(paciente.fechaNacimiento);
          } else {
            paciente.fechaNacimiento = null; // O lo dejas sin asignar
          }

          this.formRef.current.setFieldsValue(paciente)
        } else {
          message.error("No se encontro informacion");
        }
      });
  }

  onFinish(values) {
    if (values?.nombre) {
      this.setState({ loading: true });
      axios
        .post(
          "pacientes/editarPaciente",
          {
            ...values,
            empresaId: this.props.empresaId,
            pacienteId: this.props.pacienteId
          },
          {
            headers: this.props.headersToken,
          }
        )
        .then((res) => {
          this.setState({ loading: false });
          if (res.data.success === 2) {
            message.success("Paciente agregado exitosamente");
            this.cerrarEditarPaciente();
          } else if (res.data.success === 1) {
            message.error("No se pudo agregar el paciente");
          } else {
            message.error("Sucedió un error y no se pudo agregar el paciente");
          }
        })
        .catch((error) => {
          this.setState({ loading: false });
          message.error("Error al comunicarse con el servidor");
        });
    } else {
      message.info("Proporcione al menos el nombre del paciente");
    }
  }


  cerrarEditarPaciente = () => {
    this.props.cerrarEditarPaciente();
    if (this.formRef.current) {
      this.formRef.current.resetFields();
    }
  };

  render() {
    return (
      <ModalItem
        title="Editar Paciente"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarEditarPaciente.bind(this)}
      >
        <Form
          ref={this.formRef}
          name="modalEditarPaciente"
          layout
          bottom={
            <ButtonItem
              type="primary"
              htmlType="submit"
              style={{ display: "block", margin: "0 0 0 auto" }}
              loading={this.state.loading}
            >
              Guardar
            </ButtonItem>
          }

          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
          <FormItem
            name="codigo"
            label="Número de Paciente"
            required
            margin
          >
            <InputItem disabled placeholder="Ingresa el número de paciente" />
          </FormItem>

          <FormItem
            name="nombre"
            label="Nombre del Paciente"
            required
            margin
          >
            <InputItem placeholder="Ingresa el nombre del paciente" />
          </FormItem>
          <FormItem
            name="cirugia"
            label="Cirugia del Paciente"
            margin
          >
            <InputItem placeholder="Ingresa la cirugia del paciente" />
          </FormItem>
          <FormItem
            name="telefono"
            number
            margin
            label="Teléfono"
          >
            <InputNumberItem placeholder="Teléfono" celular />
          </FormItem>
          <FormItem
            name="correo"
            margin
            pattern
            max={200}
            email
            label="Correo"
          >
            <InputItem placeholder="Correo" />
          </FormItem>
          <FormItem
            name="sexo"
            label="Sexo del Paciente"
            margin

          >
            <SelectItem placeholder="Seleccione el sexo del paciente">
              <Option value={1}>Masculino</Option>
              <Option value={2}>Femenino</Option>
              <Option value={3}>Otro</Option>
            </SelectItem>
          </FormItem>
          <FormItem
            name="fechaNacimiento"
            label="Fecha de Nacimiento"
            margin
          >
            <DatePickerItem />
          </FormItem>
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(EditarPaciente);
